import _ from 'lodash';

import FileCMSModel from '@/visa-application/models/FileCMSModel';
import CMSModel from '@/visa-application/models/CMSModel';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';

export class FloatingPromptModelCMSModel implements CMSModel {
  country: CountryCMSModel = new CountryCMSModel();
  floating_prompt = '';

  map(obj: any) {
    this.country = _.get(obj, 'country', {});
    this.floating_prompt = _.get(obj, 'translation[0].floating_prompt', '');
  }
}

export default class ApplicationCenterHomeCMSModel implements CMSModel {
  country: CountryCMSModel = new CountryCMSModel();
  title = '';
  subtitle = '';
  card_title = '';
  card_body = '';
  visa_flow_first_step = '';
  visa_flow_first_step_img: FileCMSModel = undefined;
  visa_flow_second_step = '';
  visa_flow_second_step_img: FileCMSModel = undefined;
  visa_flow_third_step = '';
  visa_flow_third_step_img: FileCMSModel = undefined;
  avs_title = '';
  start_app_title = '';
  start_app_button = '';
  start_app_button_link = '';
  start_app_button_without_visa = '';
  start_app_button_without_visa_link = '';
  opening_hours: string;
  meta_title = '';
  meta_description = '';
  meta_keywords = '';
  hide_boot_section: boolean;
  floating_prompt = '';

  map(obj: any): void {
    this.country = _.get(obj, 'country', {});
    this.title = _.get(obj, 'translation[0].title', '');
    this.subtitle = _.get(obj, 'translation[0].subtitle', '');
    this.card_title = _.get(obj, 'translation[0].card_title', '');
    this.card_body = _.get(obj, 'translation[0].card_body', '');
    this.visa_flow_first_step = _.get(obj, 'translation[0].visa_flow_first_step', '');
    this.visa_flow_first_step_img = _.get(obj, 'visa_flow_first_step_img', '');
    this.visa_flow_second_step = _.get(obj, 'translation[0].visa_flow_second_step', '');
    this.visa_flow_second_step_img = _.get(obj, 'visa_flow_second_step_img', '');
    this.visa_flow_third_step = _.get(obj, 'translation[0].visa_flow_third_step', '');
    this.visa_flow_third_step_img = _.get(obj, 'visa_flow_third_step_img', '');
    this.avs_title = _.get(obj, 'translation[0].avs_title', '');
    this.start_app_title = _.get(obj, 'translation[0].start_app_title', '');
    this.start_app_button = _.get(obj, 'translation[0].start_app_button', '');
    this.start_app_button_link = _.get(obj, 'start_app_button_link', '');
    this.start_app_button_without_visa = _.get(obj, 'translation[0].start_app_button_without_visa', '');
    this.start_app_button_without_visa_link = _.get(obj, 'start_app_button_without_visa_link', '');
    this.opening_hours = _.get(obj, 'translation[0].opening_hours', '');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
    this.floating_prompt = _.get(obj, 'translation[0].floating_prompt', '');
    this.hide_boot_section = _.get(obj, 'hide_boot_section', false);
  }
}
